import { useState, useEffect } from 'react';

export default function useIntersection (ref, threshold = 1) {
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        if(ref?.current === null) return null;
        const rc = ref.current;
        const observer = new IntersectionObserver(
            entries => entries[0].isIntersecting !== isVisible ? setVisible(entries[0].isIntersecting) : null,
            {
                threshold: threshold,
                rootMargin: "0px"
            }
        );
        rc && observer.observe(rc);
        return () => {
            rc && observer.unobserve(rc);
            observer.disconnect();
        };
    }, [ ref, threshold, isVisible ]);

    return isVisible;
};